import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { GradientButton } from '../../../components/Button';

export const StyledAiOutreachButton = styled(GradientButton)`
  width: 100%;
  cursor: pointer;
  padding: 10px 16px;
  border-radius: 50px;
`;

export const StyledLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${colorsPalettes.carbon[0]};
`;

export const StyledText = styled.div`
  ${setFontVariant('button', colorsPalettes.carbon[0])}
`;
